/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import React from "react";
import { useSelector } from "react-redux";
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function BasicTabs(props) {
  const { handleChangeTabValue, tabValue, errorMessages } = props;
  const RedColor='#a81f00'

  const classes = useStyles();

  return (
    <>
      <div data-testid='mfg-tabs' className={classes.root}>
        <AppBar position='static'>
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color='red'
            style={{ color:RedColor}}
          >
            <Tab
              label='Name and Address'
              style={{
                textTransform: "capitalize",
                padding: "6px 10px",
              }}
              value='one'
              tabIndex={0}
            />
            {(errorMessages && errorMessages.length > 0 && errorMessages.filter((x) => {
              return (
                x === constantMessageData.NAME_REQUIRED ||
                x === constantMessageData.CONTACT_TYPE_REQUIRED ||
                x === constantMessageData.ADDRESS_LINE1_REQUIRED ||
                x === constantMessageData.CITY_REQUIRED ||
                x === constantMessageData.STATE_REQUIRED ||
                x === constantMessageData.ZIP_REQUIRED ||
                x === constantMessageData.ZIP4_REQUIRED ||
                x === constantMessageData.PHONE_REQUIRED ||
                x === constantMessageData.PHONE_INVALID_ERROR ||
                x === constantMessageData.EMAIL_REQUIRED ||
                x === constantMessageData.EMAIL_INVALID
              );
            }).length > 0) && <span className="tab-error">!</span>}
            <Tab
              label='Other Information'
              style={{
                textTransform: "capitalize",
                padding: "6px 10px",
              }}
              value='two'
              tabIndex={0}
            />
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
